import { instance } from '@payments-checkout/shared/helpers/service/instance.service';
import { useSessionId } from '@payments-checkout/shared/providers';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useParams } from 'next/navigation';
import { AddressFields } from '../../types/address';

export async function sendShippingAddress(
  paymentLinkId: string,
  address: AddressFields,
  sessionId?: string
) {
  return await instance.patch(
    `paymentlinks/${paymentLinkId}/sessions/${sessionId}/shipping`,
    { ...address }
  );
}

export const useSendShippingAddress = (
  options?: Omit<
    UseMutationOptions<unknown, AxiosError, { address: AddressFields }>,
    'mutationFn'
  >
) => {
  const params = useParams<{ paymentLinkId: string }>();
  const { sessionId } = useSessionId();

  return useMutation({
    mutationFn: (variables: { address: AddressFields }) =>
      sendShippingAddress(params.paymentLinkId, variables.address, sessionId),
    ...options,
  });
};
